import { computed, observable } from "mobx"

// 独立公告页store
export class NoticePageStore {
  @observable selectedValue = ["title", "subject"]
  @observable selectData = [
    {
      label: "标题",
      value: "title",
      inputValue: "",
    },
    {
      label: "内容",
      value: "content",
      inputValue: "",
    },
    {
      label: "摘要",
      value: "subject",
      inputValue: "",
    },
  ]
  @observable detailShow = false // 不随路由匹配展示消息详情，而是等内容加载完后再展示
  @observable categoryList = []
  @observable dataList = []
  @observable categoryId = "" // 类目ID
  @observable currentPage = 1 // 当前页数
  @observable pageSize = 10 // 每页多少条
  @observable total = 100 // 总页数
  @observable pageSizeList = [10, 20, 50]
  @observable loading = false
  @observable isHomePage = 0 // 是否取首页数据
}

// 首页公告页store
class DeskAnnouncementStore {
  slider = null // 当前滑动容器引用
  recorder = [] // 记录数组，是当前播放order的镜象
  @observable currentPageIndex = 0 // 当前页面索引
  @observable noticeDataWithoutPicture = [] // 通知数据（不带图片）
  @observable noticeDataWithPicture = [] // 通知数据（带图片）

  @computed
  get autoSizedNoticeDataWithoutPicture() {
    return (this.noticeDataWithoutPicture || []).slice(0, 6)
  }

  @computed
  get autoSizedNoticeDataWithPicture() {
    return (this.noticeDataWithPicture || []).slice(0, 5)
  }
}
export class NoticeStore {
  @observable unreadCount = 0
  @observable noticeReadedId = 0 // 通知标记为已读时，通知的id
  @observable noticePageStore = new NoticePageStore()
  @observable deskAnnouncementStore = new DeskAnnouncementStore()
}

export default new NoticeStore()
